import React, { useEffect, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import { api } from '../../../configs'
import { addAciveClass, nowDate } from '../../../tools'

// const FranchiseeFreeServiceBizNoTypeField = props => {
//   const [bizNoType, setBizNoType] = useState('p')
//   const changeBizNoType = x => {
//     props.setValue('biz_no_type', 'c' === x ? 'c' : 'p')
//     setBizNoType(x)
//   }
//   return (
//     <div className="customer_box">
//       <div className="biz_no_type_labels">
//         <div>
//           <input id="p" type="radio" name="biz_no_type" value="p" checked={bizNoType === 'p'} onChange={() => changeBizNoType('p')}></input>
//           <label htmlFor="p" className="biz_no_type_label">
//             개인/개인사업자
//           </label>
//         </div>
//         <div>
//           <input id="c" type="radio" name="biz_no_type" value="c" checked={bizNoType === 'c'} onChange={() => changeBizNoType('c')}></input>
//           <label htmlFor="c" className="biz_no_type_label">
//             법인 사업자
//           </label>
//         </div>
//       </div>
//     </div>
//   )
// }
const BizNoTypeField = props => {
  // if (props.isSpgeCF) {
  //   return <FranchiseeFreeServiceBizNoTypeField {...props} />
  // }
  // const changeBizNoType = e => {
  //   const x = e.target.value
  //   props.setValue('biz_no_type', 'c' === x ? 'c' : 'p')
  // }
  return (
    <div className="customer_box">
      <label htmlFor="biz_no_type">사업 유형</label>
      <select
        className="customer_box radio_group"
        {...props.register('biz_no_type')}
        name="biz_no_type"
        id="biz_no_type"
        // onChange={changeBizNoType}
      >
        <option value="p">개인/개인사업자</option>
        <option value="c">법인 사업자</option>
      </select>
    </div>
  )
}

const BizNoField = ({ placeholder, ...props }) => (
  <div
    id="biz_no_field"
    className="customer_box"
    style={{
      marginTop: '30px'
    }}>
    <label htmlFor="biz_no">사업자 등록번호</label>
    <div className="input_btn_box">
      <input
        type="text"
        name="biz_no"
        id="biz_no"
        {...props.register('biz_no', {
          onChange: e => props.onChangeBizNo(e)
        })}
        className={props.errors.biz_no ? 'error' : ''}
        autoComplete="off"
        // style={props.isSpgeCF ? { maxWidth: '100%' } : {}}
        placeholder={placeholder || ''}
        readOnly={props.isDisabled ?? false}
      />
      <button
        id="biz_no_btn"
        disabled={props.isDisabled ?? false}
        type="button"
        className={'btn_style ' + (props.bizNoHelper ? 'error' : '')}
        style={{ fontWeight: '500' }}
        onClick={() => props.getApplyBizNoValid()}>
        사업자 번호 검증
      </button>
    </div>

    {props.isBiznoValid && <p className="caution color_blue">{props.isBiznoValid}</p>}
    <p className="caution color_r">{props.bizNoHelper ? props.bizNoHelper : props.errors.biz_no && props.errors.biz_no.message}</p>
    {/* {props.isSpgeCF && (
      <div className="mx-auto d-flex-center" style={{ width: '239px' }}>
        <button type="button" className={'btn_style spge-cf--btn ' + (props.bizNoHelper ? 'error' : '')} onClick={() => props.getApplyBizNoValid()}>
          사업자 번호 검증
        </button>
      </div>
    )} */}
  </div>
)

const ShopNameField = ({ label, placeholder, ...props }) => {
  return (
    <div className="customer_box">
      <label htmlFor="shop_name">{label || '사업자 상호'}</label>
      <input
        type="text"
        name="shop_name"
        id="shop_name"
        disabled={!props.bizNoTrue}
        {...props.register('shop_name')}
        className={props.errors.shop_name ? 'error' : ''}
        autoComplete="off"
        placeholder={placeholder || ''}
        readOnly={props.isNormal2Premium || props.notEditInfo}
      />
      <p className="caution">{props.errors.shop_name?.message ?? <>예&#41; 멕시카나 연남점</>}</p>
    </div>
  )
}

const FranchiseeNameField = ({ label, placeholder, ...props }) => {
  return (
    <div className="customer_box">
      <label htmlFor="franchisee_name">{'프랜차이즈명'}</label>
      <input
        type="text"
        name="franchisee_name"
        id="franchisee_name"
        disabled={!props.bizNoTrue}
        {...props.register('franchisee_name')}
        className={props.errors.franchisee_name ? 'error' : ''}
        autoComplete="off"
        placeholder={'법인명을 입력해주세요.'}
      />
      <p className="caution">{props.errors.franchisee_name?.message}</p>
    </div>
  )
}

const OwnerNameField = ({ placeholder, ...props }) => {
  const { isSpgeF } = props
  return (
    <div className="customer_box">
      <label htmlFor="owner_name">대표자명</label>
      <input
        type="text"
        name="owner_name"
        id="owner_name"
        disabled={!props.bizNoTrue}
        autoComplete="off"
        {...props.register('owner_name', {
          onChange: props.ownerNameSetting
        })}
        className={props.errors.owner_name ? 'error' : ''}
        placeholder={placeholder || ''}
        readOnly={props.isNormal2Premium || props.notEditInfo}
      />
      {!isSpgeF && <p className="caution">{props.errors.owner_name?.message ?? <>예&#41; 홍길동</>}</p>}
      {isSpgeF && <p className="caution">{props.errors.owner_name?.message}</p>}
    </div>
  )
}

// const CountDownNum = ({ setShowOtp }) => {
//   const [count, setCount] = useState(179)
//   const mm = String(Math.floor(count / 60)).padStart(2, '0')
//   const ss = String(count % 60).padStart(2, '0')

//   useEffect(() => {
//     if (count === 0) {
//       setShowOtp(false)
//       return
//     }
//     const inv = setTimeout(() => {
//       setCount(count - 1)
//     }, 1000)
//     return () => clearTimeout(inv)
//   }, [count])
//   return (
//     <span className="countdown">
//       {mm}:{ss}
//     </span>
//   )
// }

// const OtpInput = ({ setShowOtp, otpError, setOtpError, onChange }) => {
//   // onChange = function() {}
//   const onInput = e => {
//     setOtpError('')
//     if (e.target.value.length === 6) {
//       onChange(e.target.value)
//     }
//   }

//   return (
//     <>
//       <div className={'customer_box'}>
//         <div className={'relative ' + (otpError ? 'error' : '')}>
//           <input maxLength={6} autoComplete="off" type="number" name="otpHolder" id="otpHolder" onChange={onInput} />
//           <CountDownNum setShowOtp={setShowOtp} />
//         </div>
//         <p className="caution">{otpError}</p>
//       </div>
//     </>
//   )
// }

// const apiSendOTP = async ({ phone }) => {
//   return new Promise((resolve, reject) => {
//     const data = { phone }
//     api
//       .post('/api/v1/cmmn/sendOTP', data)
//       .then(response => {
//         console.log('response', response)
//         const resDate = response.data
//         if (resDate.result_code === '00000') {
//           resolve({ ...data, ...resDate.data })
//         } else {
//           reject({ code: resDate.result_code, message: resDate.result_msg })
//         }
//       })
//       .catch(error => {
//         reject(error?.message)
//       })
//   })
// }

// const apiVerifyOTP = async ({ phone, otp }) => {
//   return new Promise((resolve, reject) => {
//     const data = { phone, otp }
//     api
//       .post('/api/v1/cmmn/verifyOTP', data)
//       .then(response => {
//         console.log('response', response)
//         const resDate = response.data
//         if (resDate.result_code === '00000') {
//           resolve({ ...data, ...resDate.data })
//         } else {
//           reject({ code: resDate.result_code, message: resDate.result_msg })
//         }
//       })
//       .catch(error => {
//         reject(error?.message)
//       })
//   })
// }

const apiCheckCeoId = async data => {
  return new Promise((resolve, reject) => {
    api
      .post('/api/v1/cmmn/checkCeoId', data)
      .then(response => {
        console.log('response', response)
        const resDate = response.data
        if (resDate.result_code === '00000') {
          resolve({ ...data, ...resDate.data })
        } else {
          reject({ code: resDate.result_code, message: resDate.result_msg })
        }
      })
      .catch(error => {
        reject(error?.message)
      })
  })
}

// const OwnerPhoneNoFieldFree = props => {
//   const [showOtp, setShowOtp] = useState(false)
//   const [otpStage, setOtpStage] = useState('SEND')

//   const [otpError, setOtpError] = useState('')

//   const sendOtp = () => {
//     const phone = props.formRef.current.querySelector('[name=owner_phone_no]').value
//     if (!isCellPhone(phone)) {
//       props.setError('owner_phone_no', { type: 'custom', message: '전화번호가 올바르지 않습니다' })
//       return
//     }
//     apiSendOTP({ phone })
//     setOtpStage('SENT_&_WAIT_VERIFIED')
//     setShowOtp(true)
//   }

//   const otpInputOnChange = v => {
//     const phone = props.formRef.current.querySelector('[name=owner_phone_no]').value
//     const otp = props.formRef.current.querySelector('[name=otpHolder]').value
//     console.log('otp', otp)
//     apiVerifyOTP({ phone, otp }).then(data => {
//       console.log(data)
//       if (data?.verified) {
//         setOtpStage('VERIFIED')
//         setShowOtp(false)
//         props.setValue('otp', otp)
//         setOtpError('')
//       } else {
//         setOtpError('인증번호가 올바르지 않아요.')
//       }
//     })
//   }

//   const errorText = props.errors.owner_phone_no?.message || props.errors.otp?.message
//   return (
//     <>
//       <div className="customer_box">
//         <label htmlFor="owner_phone_no">대표자 휴대폰</label>
//         <div className="d-flex-center gap-10px">
//           <input
//             autoComplete="off"
//             type="number"
//             name="owner_phone_no"
//             id="owner_phone_no"
//             disabled={!props.bizNoTrue}
//             {...props.register('owner_phone_no', {
//               onChange: props.ownerPhoneNoSetting
//             })}
//             className={errorText ? 'error' : ''}
//           />
//           <div className="flex-1-0-auto" style={{ width: '129px' }}>
//             {(otpStage === 'SEND' || otpStage === 'SENT_&_WAIT_VERIFIED') && (
//               <button type="button" className={'btn_style spge-cf--btn '} onClick={sendOtp} disabled={otpStage === 'SENT_&_WAIT_VERIFIED'}>
//                 인증번호 받기
//               </button>
//             )}
//             {otpStage === 'VERIFIED' && (
//               <button type="button" className={'btn_style spge-cf--btn '} onClick={sendOtp}>
//                 인증번호 재전송
//               </button>
//             )}
//           </div>
//         </div>
//         {}
//         <Caution errorText={errorText}>{'숫자만 입력해주세요.'}</Caution>
//       </div>

//       {showOtp && <OtpInput setOtpError={setOtpError} otpError={otpError} onChange={otpInputOnChange} setShowOtp={setShowOtp} />}
//     </>
//   )
// }

const ContactManagerNameField = ({ label, placeholder, ...props }) => {
  return (
    <div className="customer_box">
      <label htmlFor="contact_manager_name">{label || '담당자 휴대폰'}</label>
      <input
        autoComplete="off"
        type="text"
        name="contact_manager_name"
        id="contact_manager_name"
        disabled={!props.bizNoTrue}
        {...props.register('contact_manager_name')}
        className={props.errors.contact_manager_name ? 'error' : ''}
        placeholder={placeholder || ''}
      />

      <p className="caution">{props.errors.contact_manager_name?.message}</p>
    </div>
  )
}
const ContactManagerEmailField = ({ label, placeholder, ...props }) => {
  return (
    <div className="customer_box">
      <label htmlFor="contact_manager_email">{label || '담당자 이메일'}</label>
      <input
        autoComplete="off"
        type="email"
        name="contact_manager_email"
        id="contact_manager_email"
        disabled={!props.bizNoTrue}
        {...props.register('contact_manager_email')}
        className={props.errors.contact_manager_email ? 'error' : ''}
        placeholder={placeholder || ''}
      />

      <p className="caution">{props.errors.contact_manager_email?.message}</p>
    </div>
  )
}
const OwnerPhoneNoField = ({ label, placeholder, ...props }) => {
  return (
    <div className="customer_box">
      <label htmlFor="owner_phone_no">{label || '대표자 휴대폰'}</label>
      <input
        autoComplete="off"
        type="number"
        name="owner_phone_no"
        id="owner_phone_no"
        disabled={!props.bizNoTrue}
        {...props.register('owner_phone_no', {
          onChange: props.ownerPhoneNoSetting
        })}
        className={props.errors.owner_phone_no ? 'error' : ''}
        placeholder={placeholder || ''}
        readOnly={props.isNormal2Premium || props.notEditInfo}
      />

      <p className="caution">{props.errors.owner_phone_no?.message}</p>
    </div>
  )
}

const IdFieldInput = ({ isSpgeCF, isSpgeF, checkIdField, placeholder, ...props }) => {
  return (
    <input
      type="text"
      name="id"
      id="id"
      disabled={!props.bizNoTrue}
      readOnly={props.shop_idx === null || props.reSignup || props.isNormal2Premium || props.notEditInfo}
      {...props.register('id', {
        onChange: e => {
          props.idSetting(e)
        }
      })}
      onBlur={
        isSpgeF || isSpgeCF
          ? e => {
              const errorType = props.errors.id?.type
              if (!errorType || errorType === 'custom') {
                checkIdField()
              }
            }
          : undefined
      }
      className={props.errors.id ? 'error' : ''}
      autoComplete="off"
      placeholder={placeholder || (isSpgeCF ? '' : '5~15자리를 입력해주세요.')}
      value={props.shopId}
    />
  )
}

const IdFieldFree = props => {
  const checkIdField = () => {
    const id = props.formRef.current.querySelector('[name=id]').value
    apiCheckCeoId({ id }).then(data => {
      const existed = data?.existed
      if (existed) props.setError('id', { type: 'custom', message: '사용중인 ID입니다' })
    })
  }
  return (
    <div className="customer_box">
      <label htmlFor="id">아이디</label>
      <div className="d-flex-center gap-10px">
        <IdFieldInput checkIdField={checkIdField} {...props} />
        {/* <div className="flex-1-0-auto" style={{ width: '129px' }}>
          <button type="button" className={'btn_style spge-cf--btn '} onClick={checkIdField}>
            중복확인
          </button>
        </div> */}
      </div>
      <Caution errorText={props.errors.id?.message}>{'5~15자리를 입력해주세요.'}</Caution>
    </div>
  )
}

const IdField = ({ label, ...props }) => {
  if (props.isSpgeF || props.isSpgeCF) {
    return <IdFieldFree {...props} />
  }
  return (
    <div className="customer_box">
      <label htmlFor="id">{label ?? 'ID'}</label>
      <IdFieldInput {...props} />
      <p className="caution">{props.errors.id?.message}</p>
    </div>
  )
}

const PasswordField = ({ label, placeholder, ...props }) => (
  <div className="customer_box">
    <label htmlFor="password">{label || '비밀번호'}</label>
    <input
      type="password"
      name="password"
      id="password"
      disabled={!props.bizNoTrue}
      readOnly={props.shop_idx === null || props.reSignup || props.isNormal2Premium || props.notEditInfo || props.notEditInfo}
      autoComplete="off"
      {...props.register('password', {
        onChange: props.passwordSetting
      })}
      className={props.errors.password ? 'error' : ''}
      placeholder={placeholder || (props.isSpgeCF ? '' : '영문, 숫자, 특수문자 5~20자')}
      value={props.shopPassword}
    />
    <p className="caution">{props.errors.password?.message || (props.isSpgeCF ? '영문, 숫자, 특수문자 5~20자 내외로 입력해주세요.' : '')}</p>
  </div>
)

const ConfirmPasswordField = ({ label, placeholder, ...props }) => (
  <div className="customer_box">
    <label htmlFor="confirmPassword">{label || '비밀번호 확인'}</label>
    <input
      autoComplete="off"
      type="password"
      name="confirmPassword"
      id="confirmPassword"
      disabled={!props.bizNoTrue}
      readOnly={props.shop_idx === null || props.reSignup || props.isNormal2Premium || props.notEditInfo}
      {...props.register('confirmPassword', {
        onChange: props.confirmPassword
      })}
      className={props.errors.confirmPassword ? 'error' : ''}
      placeholder={placeholder || (props.isSpgeCF ? '' : '비밀번호를 한번 더 입력해 주세요.')}
      value={props.shopConfirmPassword}
    />

    <p className="caution">{props.errors.confirmPassword?.message || (props.isSpgeCF ? '비밀번호를 한번 더  입력해주세요.' : '')}</p>
  </div>
)

const BankAccountWrap = props => (
  <div className="bank_account_wrap">
    <div className="wrap_tit">
      계좌 출금 정보<span className="color_r">*</span>
      <div className="m_t_10 font_12 font_nomal color_blue">출금계좌 등록이 완료되면 영업일 2일 내에 선택하신 은행에서 알림톡이 발송됩니다.</div>
    </div>

    <div className="bank_account_box">
      <label htmlFor="account_name">예금주명</label>
      <input
        autoComplete="off"
        type="text"
        name="account_name"
        id="account_name"
        disabled={!props.bizNoTrue}
        {...props.register('account_name', {
          onChange: props.accountNameSetting
        })}
        className={props.errors.account_name ? 'error' : ''}
      />
      <p className="caution">예&#41; 홍길동</p>
    </div>

    <div className="bank_account_box">
      <label htmlFor="account_phone_no">예금주 휴대폰</label>
      <input
        type="number"
        name="account_phone_no"
        id="account_phone_no"
        autoComplete="off"
        disabled={!props.bizNoTrue}
        {...props.register('account_phone_no')}
        className={props.errors.account_phone_no ? 'error' : ''}
      />
      <p className="caution">{props.errors.account_phone_no?.message}</p>
    </div>

    <div className="bank_account_box">
      <label htmlFor="bank_code">은행</label>
      <select
        name="bank_code"
        id="bank_code"
        {...props.register('bank_code')}
        className={props.errors.bank_code ? 'error' : ''}
        disabled={!props.bizNoTrue}>
        {props.bank_code.map(item => (
          <option value={item.value} key={item.value}>
            {item.name}
          </option>
        ))}
      </select>
      <p className="caution">{props.errors.bank_code?.message}</p>
    </div>

    <div className="bank_account_box">
      <label htmlFor="account_no">계좌번호</label>
      <input
        type="text"
        name="account_no"
        id="account_no"
        autoComplete="off"
        disabled={!props.bizNoTrue}
        {...props.register('account_no')}
        className={props.errors.account_no ? 'error' : ''}
      />
      <p className="caution">{props.errors.account_no?.message}</p>
    </div>

    <div className="bank_account_box">
      <label htmlFor="account_jumin_biz_no">예금주 생년월일(6자리) / 사업자번호(10자리)</label>
      <input
        type="text"
        name="account_jumin_biz_no"
        id="account_jumin_biz_no"
        autoComplete="off"
        disabled={!props.bizNoTrue}
        {...props.register('account_jumin_biz_no')}
        className={props.errors.account_jumin_biz_no ? 'error' : ''}
      />

      <p className="caution">{props.errors.account_jumin_biz_no?.message}</p>
    </div>

    <div className="bank_account_box bank_account_info">
      <p className="bank_account_info_tit">서비스 비용 출금 정보</p>
      <ul>
        <li>&#183; 서비스 이용 비용 출금은 매월 1일~13일 출금됩니다.</li>
        <li>&#183; 지속적으로 미출금시 서비스 이용이 제한됩니다.</li>
        <li>&#183; 서비스 재가입 가맹점의 경우 첫달 서비스비용은 20,000원으로 출금됩니다.</li>
      </ul>
    </div>
  </div>
)

const AccountCheck = props => (
  <div className="terms_box diffrent_account" id="account_check">
    <div className="terms_check">
      <input
        type="checkbox"
        name="different_customer"
        id="different_account"
        autoComplete="off"
        {...props.register('different_account')}
        onClick={props.differentAccountCheck}
      />
      <label htmlFor="different_account">
        <em></em> 신청자와 예금주가 다른 경우 체크
      </label>
    </div>
    <div className="terms_sign">
      <label htmlFor="apply_name">예금주</label>
      <input
        type="text"
        name="apply_name"
        id="apply_name"
        readOnly={true}
        autoComplete="off"
        {...props.register('apply_name')}
        className={props.errors.apply_name ? 'error' : ''}
      />

      <label htmlFor="account_relation">신청자와의 관계</label>
      <input
        type="text"
        name="account_relation"
        id="account_relation"
        autoComplete="off"
        {...props.register('account_relation')}
        className={props.errors.account_relation ? 'error' : ''}
      />

      <p
        className="terms_agree_date"
        dangerouslySetInnerHTML={{
          __html: nowDate()
        }}></p>
      <div className="sign">
        <p className={props.differentAccountIsSigned ? 'sign_placeholder blind' : 'sign_placeholder'}>
          서명<span className="color_r">(필수)</span>
        </p>
        <SignatureCanvas
          clearOnResize={false}
          ref={props.different_account_sign_ref}
          id="different_account_sign"
          canvasProps={{
            className: 'signature_canvas'
          }}
          onBegin={() => {
            props.setDifferentAccountIsSigned(true)
            props.setDifferentAccountHelper('')
          }}
        />
        <button
          className="sign_reset_btn"
          type="button"
          onClick={() => {
            props.different_customer_sign_ref?.current?.clear() // 리셋

            props.setDifferentAccountIsSigned(false)
          }}></button>
      </div>
      <div className="p_t_10 explain_text">{props.differentAccountHelper}</div>
    </div>
  </div>
)

const UiSignature = props => (
  <>
    <p
      className="terms_agree_date"
      dangerouslySetInnerHTML={{
        __html: nowDate()
      }}></p>
    <div className="sign">
      <p className={props.differentCustomerIsSigned ? 'sign_placeholder blind' : 'sign_placeholder'}>
        서명<span className="color_r">(필수)</span>
      </p>
      <SignatureCanvas
        clearOnResize={false}
        id="different_customer_sign"
        ref={props.different_customer_sign_ref}
        canvasProps={{
          className: 'signature_canvas'
        }}
        onBegin={() => {
          props.setDifferentCustomerIsSigned(true)
          props.setDifferentCustomerHelper('')
        }}
      />

      <button
        className="sign_reset_btn"
        type="button"
        onClick={() => {
          props.different_customer_sign_ref?.current?.clear() // 리셋

          props.setDifferentCustomerIsSigned(false)
        }}></button>
    </div>
  </>
)

const UiTermCheck = props => (
  <div className="terms_check">
    <input
      type="checkbox"
      name="different_apply_customer"
      id="different_apply_customer"
      autoComplete="off"
      {...props.register('different_apply_customer', {
        onChange: props.differentApplyCustomerCheck
      })}
    />
    <label htmlFor="different_apply_customer">
      <em></em>대표자와 신청자가 다른 경우 체크
    </label>
  </div>
)

const UiDifferentCustomerName = props => (
  <>
    <label htmlFor="different_customer_name">신청자</label>
    <input
      type="text"
      name="different_customer_name"
      id="different_customer_name"
      {...props.register('different_customer_name')}
      readOnly={props.diffApplyCustomerCheck}
      className={props.errors.different_customer_name ? 'error' : ''}
    />
    <label htmlFor="apply_phone_no">신청자 휴대폰</label>
    <input
      type="number"
      name="apply_phone_no"
      id="apply_phone_no"
      readOnly={props.diffApplyCustomerCheck}
      autoComplete="off"
      {...props.register('apply_phone_no')}
    />

    <p className="caution">{props.errors.apply_phone_no?.message}</p>
  </>
)

const TermsWrap = ({ isSpgeCF, isSpgeF, ...props }) => {
  return (
    <div id="terms_wrap" className="terms_wrap">
      <p id="terms_wrap--title" className="wrap_tit">
        {isSpgeF ? '약관 동의' : '신청자 확인 및 약관 동의'}
        <span className="color_r">*</span>
      </p>
      {isSpgeCF && (
        <p className="color_blue font_nomal" style={{ marginBottom: '14px' }}>
          {/* 신청자 휴대폰번호로 스폰지C 서비스 관련 알림톡이 발송됩니다. */}
          신청자 전화번호로 스폰지R 프랜차이즈 서비스 관련 알림톡이 발송됩니다.
        </p>
      )}
      {!isSpgeF && (
        <div className="terms_box" id="apply_check">
          <UiTermCheck {...props} />
          <div className="terms_sign">
            <UiDifferentCustomerName {...props} />
            <UiSignature {...props} />
            <div className="p_t_10 explain_text">{props.differentCustomerHelper}</div>
          </div>
        </div>
      )}

      {!isSpgeCF && !isSpgeF && <AccountCheck {...props} />}
      {(isSpgeF || isSpgeCF) && (
        <div style={{ marginBottom: '14px' }}>
          <div style={{ marginBottom: '0px' }} id="agree_yn2--box" className={'terms_box ' + (props.errors.agree_yn2 ? 'error' : '')}>
            <div className="terms_check">
              <input
                type="checkbox"
                name="agree_yn2"
                id="agree_yn2"
                autoComplete="off"
                {...props.register('agree_yn2')}
                className={props.errors.agree_yn2 ? 'error' : ''}
              />
              <label htmlFor="agree_yn2">
                <em></em> {isSpgeF ? '이용약관 동의' : '약관 동의'}
              </label>
              <p className="terms_open" onClick={props.termsPopupOpen}></p>
            </div>
          </div>
          <p style={{ marginBottom: '0px', marginTop: '4px' }} className="caution w_100">
            {props.errors.agree_yn2?.message}
          </p>
        </div>
      )}
      <div style={{ marginBottom: '14px' }}>
        <div style={{ marginBottom: '0px' }} id="agree_yn--box" className={'terms_box ' + (props.errors.agree_yn ? 'error' : '')}>
          <div className="terms_check">
            <input
              type="checkbox"
              name="agree_yn"
              id="agree_yn"
              autoComplete="off"
              {...props.register('agree_yn')}
              className={props.errors.agree_yn ? 'error' : ''}
            />
            <label htmlFor="agree_yn">
              <em></em> 개인정보 및 고유식별정보 수집 및 이용 동의
            </label>
            <p className="terms_open" onClick={props.termsPopupOpen}></p>
          </div>
        </div>
        <p style={{ marginBottom: '0px', marginTop: '4px' }} className="caution w_100">
          {props.errors.agree_yn?.message}
        </p>
      </div>

      {isSpgeCF && (
        <div style={{ marginBottom: '14px' }}>
          <div style={{ marginBottom: '0px' }} id="agree_yn3--box" className={'terms_box ' + (props.errors.agree_yn3 ? 'error' : '')}>
            <div className="terms_check">
              <input
                type="checkbox"
                name="agree_yn3"
                id="agree_yn3"
                autoComplete="off"
                {...props.register('agree_yn3')}
                className={props.errors.agree_yn3 ? 'error' : ''}
              />
              <label htmlFor="agree_yn3">
                <em></em> 프랜차이즈 정보 제공 동의
              </label>
              <p className="terms_open" onClick={props.termsPopupOpen4CF}></p>
            </div>
          </div>
          <p style={{ marginBottom: '0px', marginTop: '4px' }} className="caution w_100">
            {props.errors.agree_yn3?.message}
          </p>
        </div>
      )}
    </div>
  )
}

const SubmitWrapText = ({ isSpgeF, isSpgeCF }) => {
  if (isSpgeF) {
    return (
      // <p style={{ textAlign: 'justify', marginBottom: '40px' }}>
      //   본 서비스 신청과 관련하여 서비스 내용, 출금 정보, 이용 약관을 충분히 숙지하고, 하이픈코퍼레이션 CMS 자동이체를 신청하기 위해 금융거래 정보
      //   제공 및 개인정보의 수집, 이용, 개인정보 제3자 제공에 동의하며. 이에 본 서비스를 신청합니다.
      // </p>
      <p style={{ textAlign: 'justify', marginBottom: '40px' }}>
        서비스 가입 신청이 접수되면 고객센터(050-7964-1000)에서 안내 전화를 드립니다. 스폰지R 프랜차이즈 가입 승인이 완료되면 담당자 휴대폰번호로
        아이디와 초기비밀번호를 보내드립니다
      </p>
    )
  }
  if (isSpgeCF) {
    return (
      <p style={{ textAlign: 'justify', marginBottom: '24px' }}>
        {/* 본 서비스 신청과 관련하여 서비스 내용, 이용 약관을 충분히 숙지하고, 개인정보의 수집, 이용, 개인정보 제3자 제공에 동의하며, 이에 본 서비스를
        신청합니다. 서비스 신청이 완료되면 영업일 3일 이내에 스폰지 F 서비스를 이용하실 수 있습니다. */}
        본 서비스 신청과 관련하여 서비스 내용, 이용 약관을 충분히 숙지하고, 개인정보의 수집, 이용, 개인정보 제3자 제공에 동의하며, 이에 본 서비스를
        신청합니다.
        <br />
        서비스 신청이 완료되면 영업일 3일 이내에 스폰지R 프랜차이즈 서비스를 이용하실 수 있습니다.
      </p>
    )
  }
  return (
    <p>
      본 서비스 신청과 관련하여 서비스 내용, 출금 정보, 이용 약관을 충분히 숙지하고, 하이픈코퍼레이션 CMS 자동이체를 신청하기 위해 금융거래 정보 제공
      및 개인정보의 수집, 이용, 개인정보 제3자 제공에 동의하며. 이에 본 서비스를 신청합니다.
    </p>
  )
}
const SubmitWrap = props => {
  const { isSpgeF, isSpgeCF, isServiceManager } = props
  return (
    <div id="submit-wrap" className="submit_wrap">
      <SubmitWrapText {...props} />

      {!isSpgeCF && !isSpgeF && (
        <div className="submit_box preview">
          <div>
            <div className="service_tooltip">
              <p>시작예정일</p>
              <p className="tooltip" onClick={addAciveClass}></p>
              <div className="tooltip_text">시작 예정일에 신청하신 계정으로 신청일자부터 등록된 리뷰가 수집되고 사장님 댓글이 관리됩니다.</div>
            </div>
            <div className="bold service_date">{props.serviceStartDt}</div>
          </div>

          {!isServiceManager && (
            <div>
              <p>출금예정일</p>
              <div className="bold service_date">{props.withdrawalDt}</div>
            </div>
          )}
        </div>
      )}
      <button type="submit" className="btn_default" disabled={props.btnState}>
        {!props.btnState ? '서비스 신청하기' : '서비스 신청중'}
      </button>
    </div>
  )
}

const ApplicationHeader = ({ isSpgeF, isSpgeCF, isNormal2Premium, isSpgeCFConfirm, ...props }) => {
  //헤더 스크롤
  const [bodyScrollY, setBodyScrollY] = useState(0) // 스크롤값을 저장하기 위한 상태
  const handleFollow = () => {
    setBodyScrollY(window.scrollY) // window 스크롤 값을 bodyScrollY 저장
  }
  useEffect(() => {
    const watch = () => {
      window.addEventListener('scroll', handleFollow)
    }
    watch() // addEventListener 함수를 실행
    return () => {
      window.removeEventListener('scroll', handleFollow) // addEventListener 함수를 삭제
    }
  })
  let main_subtit
  if (isSpgeF) {
    main_subtit = '스폰지R 서비스는 프랜차이즈 가맹점의 배달앱 리뷰를 위탁 관리하는 서비스입니다.'
  } else if (isSpgeCF) {
    main_subtit = '스폰지R 서비스는 소중한 고객이 작성한 배달앱 리뷰를 위탁 관리하는 서비스입니다.'
  } else {
    main_subtit = '스폰지R 서비스는 소중한 고객이 작성한 배달앱 리뷰를 위탁 관리하는 서비스입니다.'
  }
  let main_title
  if (isSpgeCFConfirm) {
    main_title = (
      <>
        {' '}
        프랜차이즈 <br /> 정보 제공 동의서{' '}
      </>
    )
  } else if (isNormal2Premium) {
    main_title = (
      // <>
      //   {' '}
      //   스폰지R 프리미엄 서비스 <br /> 개인 가맹점 전환 신청서{' '}
      // </>
      <>
        {' '}
        스폰지R 서비스 <br /> 프랜차이즈 프리미엄 가입 신청서{' '}
      </>
    )
  } else if (isSpgeF) {
    main_title = (
      <>
        {' '}
        스폰지R <br /> 프랜차이즈 가입 신청서{' '}
      </>
    )
  } else if (isSpgeCF) {
    main_title = (
      // <>
      //   {' '}
      //   스폰지R <br /> 프랜차이즈 서비스 신청서{' '}
      // </>
      <>
        {' '}
        스폰지R 서비스 <br /> 프랜차이즈 일반 가입 신청서{' '}
      </>
    )
  } else {
    main_title = (
      <>
        {' '}
        스폰지R <br /> 프리미엄 신청서{' '}
      </>
    )
  }
  return (
    <div className={bodyScrollY < 276 ? 'main_wrap' : 'main_wrap scroll'}>
      <div className="header">
        <div className="logo_brg"></div>
        {!props.location?.state?.isMain && (
          <div className="env_state">
            {process.env.REACT_APP_NODE_ENV === 'development' ? '[개발서버] ' : ''}
            {props.managerName && <span>담당자 : {props.managerName}</span>}
          </div>
        )}
      </div>
      <h1>{main_title}</h1>
      <p className="main_subtit">{main_subtit}</p>
    </div>
  )
}

const Caution = ({ errorText, children }) => {
  return <p className={'caution ' + (errorText ? 'caution-error' : '')}>{errorText || children}</p>
}
export {
  ApplicationHeader,
  BankAccountWrap,
  BizNoField,
  BizNoTypeField,
  ConfirmPasswordField,
  ContactManagerEmailField,
  ContactManagerNameField,
  FranchiseeNameField,
  IdField,
  OwnerNameField,
  OwnerPhoneNoField,
  PasswordField,
  ShopNameField,
  SubmitWrap,
  TermsWrap,
  UiSignature
}
